export default __webpack_public_path__ + "public/images/mobile-generate-OTP.png";